<template>
    <div class="daily-deals-wrap" :class="{ loading: makingBid}">
        <div class="daily-deals-header clearfix">
            <h4 class="section-title" v-html="auction.name"></h4>
        </div>
        <div class="daily-deals-countdown clearfix"></div>
        <h6>
            {{ $trans('storefront::auction.card.products') }}
        </h6>
        <div class="daily-deals" ref="productsPlaceholder">
            <AuctionProductCard v-for="product in auction.products" :key="product.id" :product="product"/>
        </div>
        <h6>
            {{ $trans('storefront::auction.card.make_bid') }}
        </h6>
        <div class="bid-form d-flex">
            <input type="number" name="amount" v-model="amount" class="form-control"/>
            <button class="btn btn-primary" @click="makeBid(auction.id)">
                {{ $trans('storefront::auction.card.bid') }}
            </button>
        </div>
    </div>
</template>

<script>
    import ProductCardMixin from '../mixins/ProductCardMixin';
    import bidService from './auctions/bidService';
    import AuctionProductCard from "./AuctionProductCard.vue";
    import { slickPrevArrow, slickNextArrow } from '../functions';

    export default {
        components: {AuctionProductCard },

        mixins: [
            ProductCardMixin,
            bidService,
        ],

        props: ['auction'],
        mounted() {
            $(this.$el).find('.daily-deals-countdown').countdown({
                until: new Date(this.auction.end_date),
                format: 'DHMS',
                labels: [
                    this.$trans('storefront::product_card.years'),
                    this.$trans('storefront::product_card.months'),
                    this.$trans('storefront::product_card.weeks'),
                    this.$trans('storefront::product_card.days'),
                    this.$trans('storefront::product_card.hours'),
                    this.$trans('storefront::product_card.minutes'),
                    this.$trans('storefront::product_card.seconds'),
                ],
            });
            this.$nextTick(() => {
                $(this.$refs.productsPlaceholder).slick(this.slickOptions());
            });
        },
        methods : {
            slickOptions() {
                return {
                    rows: 0,
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rtl: window.FleetCart.rtl,
                    prevArrow: slickPrevArrow(),
                    nextArrow: slickNextArrow(),
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                };
            },
        }
    };
</script>
